module.exports = __webpack_public_path__ + "img/openstack.9e0afe4c.svg";